import { useState, useEffect } from "react";
import api from "../../axiosConfig"; // ✅ USAR API CONFIGURADA CON TOKEN
 

const useAsesoresAcademicos = () => {
  const [asesoresAcademicos, setAsesoresAcademicos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAsesoresAcademicos = async () => {
    try {
      // ✅ USAR api.get EN LUGAR DE axios.get PARA ENVIAR EL TOKEN
      const { data } = await api.get("/asesores/academicos");
      setAsesoresAcademicos(data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAsesoresAcademicos();
  }, []);

  return {
    asesoresAcademicos,
    loading,
    error,
    fetchAsesoresAcademicos,
  };
};

export default useAsesoresAcademicos;
